const GET_USER_DATA = "GET_USER_DATA";
const GET_USER_DATA_START = "GET_USER_DATA_START";
const GET_USER_DATA_FAIL = "GET_USER_DATA_FAIL";
const GET_USER_DIR = "GET_USER_DIR";
const GET_USER_COMM_DIR = "GET_USER_COMM_DIR";
const GET_USER_BATCH_DIR = "GET_USER_BATCH_DIR";
const SET_CODE_IN_LIB = "SET_CODE_IN_LIB";
const GET_USER_CODE_LIB = "GET_USER_CODE_LIB";
const REMOVE_FROM_DIR = "REMOVE_FROM_DIR";
const UPDATE_MODEL_IN_DIR = "UPDATE_MODEL_IN_DIR";
const REMOVE_FROM_COMM_DIR = "REMOVE_FROM_COMM_DIR";
const UPDATE_USER = "UPDATE_USER";
const UPDATE_USER_META = "UPDATE_USER_META";
const TOGGLE_DIR_LOADING = "TOGGLE_DIR_LOADING";
const TOGGLE_COMM_DIR_LOADING = "TOGGLE_COMM_DIR_LOADING";
const TOGGLE_BATCH_DIR_LOADING = "TOGGLE_BATCH_DIR_LOADING";
const REMOVE_CODE_FROM_LIB = "REMOVE_CODE_FROM_LIB";
const UPDATE_USER_PREFERENCES = "UPDATE_USER_PREFERENCES";
const UPDATE_USER_PRIMARY_ORG_START = "UPDATE_USER_PRIMARY_ORG_START";
const UPDATE_USER_PRIMARY_ORG_SUCCESS = "UPDATE_USER_PRIMARY_ORG_SUCCESS";
const UPDATE_USER_PRIMARY_ORG_FAIL = "UPDATE_USER_PRIMARY_ORG_FAIL";
const CONFIRM_USER_EMAIL_START = "CONFIRM_USER_EMAIL_START";
const CONFIRM_USER_EMAIL_SUCCESS = "CONFIRM_USER_EMAIL_SUCCESS";
const CONFIRM_USER_EMAIL_FAIL = "CONFIRM_USER_EMAIL_FAIL";

const FETCH_PARAMETRIC_ANALYSIS_DIR_START = "FETCH_PARAMETRIC_ANALYSIS_DIR_START";
const FETCH_PARAMETRIC_ANALYSIS_DIR_SUCCESS = "FETCH_PARAMETRIC_ANALYSIS_DIR_SUCCESS";
const FETCH_PARAMETRIC_ANALYSIS_DIR_FAIL = "FETCH_PARAMETRIC_ANALYSIS_DIR_FAIL";
const TOGGLE_PARAMETRIC_ANALYSIS_DIR_LOADING = "TOGGLE_PARAMETRIC_ANALYSIS_DIR_LOADING";

export default {
    GET_USER_DATA,
    GET_USER_DATA_START,
    GET_USER_DATA_FAIL,
    GET_USER_DIR,
    GET_USER_COMM_DIR,
    GET_USER_BATCH_DIR,
    SET_CODE_IN_LIB,
    GET_USER_CODE_LIB,
    REMOVE_FROM_DIR,
    UPDATE_MODEL_IN_DIR,
    REMOVE_FROM_COMM_DIR,
    UPDATE_USER,
    UPDATE_USER_META,
    UPDATE_USER_PREFERENCES,
    TOGGLE_DIR_LOADING,
    TOGGLE_COMM_DIR_LOADING,
    TOGGLE_BATCH_DIR_LOADING,
    REMOVE_CODE_FROM_LIB,
    FETCH_PARAMETRIC_ANALYSIS_DIR_START,
    FETCH_PARAMETRIC_ANALYSIS_DIR_SUCCESS,
    FETCH_PARAMETRIC_ANALYSIS_DIR_FAIL,
    TOGGLE_PARAMETRIC_ANALYSIS_DIR_LOADING,
    UPDATE_USER_PRIMARY_ORG_START,
    UPDATE_USER_PRIMARY_ORG_SUCCESS,
    UPDATE_USER_PRIMARY_ORG_FAIL,
    CONFIRM_USER_EMAIL_START,
    CONFIRM_USER_EMAIL_SUCCESS,
    CONFIRM_USER_EMAIL_FAIL,
};
